/* global PNotify */
import React, { createContext, useCallback, useContext, useEffect, useState, } from 'react';
import { useHistory } from 'react-router-dom';
import { NOTIFICATION_STACK, TYPES, } from '../../utils/Notifications/Notifications';
import useT from './Translations/useT';
export const useIsOnline = () => useContext(InternetConnectionContext);
export const InternetConnectionProvider = ({ children }) => {
    const t = useT();
    const [isOnline, setIsOnline] = useState(true);
    // online tracking via browser events
    const onConnect = useCallback(() => setIsOnline(true), []);
    const onDisconnect = useCallback(() => setIsOnline(false), []);
    useEffect(() => {
        window.addEventListener('offline', onDisconnect);
        window.addEventListener('online', onConnect);
        return () => {
            window.removeEventListener('offline', onDisconnect);
            window.removeEventListener('online', onConnect);
        };
    }, [onConnect, onDisconnect]);
    // block routing
    const history = useHistory();
    useEffect(() => {
        const release = history.block(() => (isOnline ? undefined : false));
        return () => release();
    }, [isOnline, history]);
    // show or hide notification
    const [notification, setNotification] = useState();
    useEffect(() => {
        if (!isOnline && !notification) {
            setNotification(new PNotify({
                title: t('Network error'),
                text: t('Internet seems not accessible, please try again later'),
                type: TYPES.ERROR,
                push: 'bottom',
                stack: NOTIFICATION_STACK,
                hide: false,
                delay: 0,
                buttons: {
                    closer: false,
                    sticker: false,
                    labels: {
                        close: t('Close'),
                        stick: t('Stick'),
                        unstick: t('Unstick'),
                    },
                },
            }));
        }
        if (isOnline && notification) {
            setNotification(undefined);
            notification.remove();
        }
    }, [t, isOnline, notification]);
    return (<InternetConnectionContext.Provider value={{
        isOnline,
        setIsOnline,
    }}>
      {children}
    </InternetConnectionContext.Provider>);
};
export const InternetConnectionContext = createContext({});
